export const APP_NAME = 'SIV-04696-IU';
export const BACK_NAME = 'sitevitrine-back';
export const FRONT_NAME = 'sitevitrine-front';
export const IP_HEADER = 'X-Forwarded-For';
